module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-basePage', {
    attrs: {
      "title": _vm.title,
      "pop": true
    }
  }, [_c('z-backForm', {
    attrs: {
      "name": 'back-ticket',
      "align": true,
      "btns": _vm._f("btnFlag")(_vm.sub.name),
      "btnText": _vm._f("btnText")(_vm.Id)
    },
    on: {
      "save": _vm.saveSet,
      "cancel": _vm.backset
    }
  }, [_c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("类型名称")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap",
    class: {
      text: _vm.systemFlag
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.systemFlag),
      expression: "systemFlag"
    }]
  }, [_vm._v(_vm._s(_vm.sub.name))]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.systemFlag),
      expression: "!systemFlag"
    }, {
      name: "arg",
      rawName: "v-arg",
      value: ([2, 15]),
      expression: "[2,15]"
    }, {
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.name),
      expression: "sub.name"
    }],
    attrs: {
      "rule": "limit",
      "placeholder": "请输入类型名称"
    },
    model: {
      value: (_vm.sub.name),
      callback: function($$v) {
        _vm.$set(_vm.sub, "name", $$v)
      },
      expression: "sub.name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("适用对象")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap",
    class: {
      text: _vm.systemFlag
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.systemFlag),
      expression: "systemFlag"
    }]
  }, [_vm._v(_vm._s(_vm._f("ticketTar")(_vm.sub.target)))]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.systemFlag),
      expression: "!systemFlag"
    }, {
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.target),
      expression: "sub.target"
    }],
    attrs: {
      "rule": "noVal",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.sub.target),
      callback: function($$v) {
        _vm.$set(_vm.sub, "target", $$v)
      },
      expression: "sub.target"
    }
  }, _vm._l((_vm.targetArr), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "value": item.val,
        "label": item.label
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("罚单金额")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap text"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.systemFlag && _vm.sub.name == '任务延期'),
      expression: "systemFlag && sub.name == '任务延期'"
    }]
  }, [_vm._v(_vm._s(_vm._f("ticket")(_vm.sub.amount, _vm.sub.name)))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.systemFlag && _vm.sub.name == '任务超期'),
      expression: "systemFlag && sub.name == '任务超期'"
    }]
  }, [_vm._v(_vm._s(_vm._f("ticket")(_vm.sub.amount, _vm.sub.name)))]), _vm._v(" "), (_vm.systemFlag && _vm.sub.name == '任务滞留') ? _c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.amount),
      expression: "sub.amount"
    }],
    staticClass: "long",
    attrs: {
      "rule": "noVal number positive",
      "placeholder": "请输入罚款数值"
    },
    model: {
      value: (_vm.sub.amount),
      callback: function($$v) {
        _vm.$set(_vm.sub, "amount", $$v)
      },
      expression: "sub.amount"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("任务金额")]), _vm._v(" "), _c('template', {
    slot: "append"
  }, [_vm._v(_vm._s("%"))])], 2) : _vm._e(), _vm._v(" "), (!_vm.systemFlag || _vm.sub.name != '任务延期' && _vm.sub.name != '任务超期' && _vm.sub.name != '任务滞留') ? _c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.amount),
      expression: "sub.amount"
    }],
    attrs: {
      "rule": "noVal number positive",
      "placeholder": "请输入罚款数值"
    },
    model: {
      value: (_vm.sub.amount),
      callback: function($$v) {
        _vm.$set(_vm.sub, "amount", $$v)
      },
      expression: "sub.amount"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(_vm._s(_vm.ticket_curr.currency_name))])], 2) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-item area"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("罚单说明")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap",
    class: {
      text: _vm.systemFlag
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.systemFlag),
      expression: "systemFlag"
    }],
    staticClass: "descript"
  }, [_vm._v(_vm._s(_vm.sub.description))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.systemFlag),
      expression: "!systemFlag"
    }, {
      name: "arg",
      rawName: "v-arg",
      value: ('罚单说明'),
      expression: "'罚单说明'"
    }, {
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.description),
      expression: "sub.description"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.sub.description),
      expression: "sub.description"
    }],
    attrs: {
      "rule": "reason describe_limit",
      "placeholder": "请输入罚单说明"
    },
    domProps: {
      "value": (_vm.sub.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sub, "description", $event.target.value)
      }
    }
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-31e8e382!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/setting/page-ticket-add.vue
// module id = 722
// module chunks = 1